import { ConfirmationDialog } from "components";
import { FaqProps } from "../state/actionType";
import { connect, useSelector } from "react-redux";
import { deleteFaq } from "../state/action";
import { FormEvent, useEffect, useState } from "react";

interface HandleDeleteFAQProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  faqData: FaqProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & HandleDeleteFAQProps;
const HandleDeleteFAQ: React.FC<Props> = ({
  closeModal,
  faqData,
  onDeleteFaq
}) => {
  const [error,setError] = useState("")
  const faqState = useSelector(
    (state: any) => state.faq.genericFaqState
  );
  
  const handleDeleteFaq = async (e: FormEvent) => {
    e.preventDefault();
    onDeleteFaq(faqData.id.toString());
    closeModal(false)
  };
   useEffect(() => {
      setError(faqState?.error);
    }, [faqState?.error]);
  return (
    <>
      <ConfirmationDialog
        message={"Are you sure you want to delete this FAQ?"}
        onCancel={closeModal}
        title={`Delete ${faqData.question}`}
        error={error}
        onConfirm={handleDeleteFaq}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteFaq: (id: string) => dispatch(deleteFaq(id)),
});

export default connect(null, mapDispatchToProps)(HandleDeleteFAQ);
